import React, { useState } from 'react';

import { TopWinsDateRange, TopWinsOrderType } from '../../../../../enums';
import { useTranslation } from '../../../../../hooks';
import { T } from '../../../../../constants';

interface FilterProps {
  orderType: TopWinsOrderType;
  dateRange: TopWinsDateRange;
  onApply: (orderType: TopWinsOrderType, dateRange: TopWinsDateRange) => void;
}

const ORDER_TYPE_OPTIONS: Array<{ key: TopWinsOrderType; label: string }> = [
  { key: TopWinsOrderType.Odd, label: T.MULTIPLIER },
  { key: TopWinsOrderType.WinAmount, label: T.WIN },
];

const DATE_RANGE_OPTIONS: Array<{ key: TopWinsDateRange; label: string }> = [
  { key: TopWinsDateRange.Today, label: T.TODAY },
  { key: TopWinsDateRange.ThisWeek, label: T.THIS_WEEK },
  { key: TopWinsDateRange.ThisMonth, label: T.THIS_MONTH },
  { key: TopWinsDateRange.AllTime, label: T.ALL_TIME },
];

export const Filter: React.FC<FilterProps> = ({ orderType, dateRange, onApply }) => {

    const t = useTranslation();

    const [draftOrderType, setDraftOrderType] = useState(orderType);
    const [draftDateRange, setDraftDateRange] = useState(dateRange);

    return (
        <div className="filter-wrp ">
            <div className="filter-elements">
                <h3 className="filter-title">{t(T.SORT_BY)}</h3>
                <div className="filter-items-wrp">
                    {ORDER_TYPE_OPTIONS.map(({ key, label }) => (
                        <div key={key} className="filter-item">
                            <label className="custom-checkbox-container">
                                <input
                                    type="checkbox"
                                    checked={draftOrderType === key}
                                    onChange={() => setDraftOrderType(key)}
                                />
                                <span className="checkmark"></span>
                                <span className="label-text">{t(label)}</span>
                            </label>
                        </div>
                    ))}
                </div>
            </div>
            <div className="filter-elements">
                <h3 className="filter-title">{t(T.FILTER_BY_DATES)}</h3>
                <div className="filter-btns-wrp">
                    {DATE_RANGE_OPTIONS.map(({ key, label }) => (
                        <button
                            key={key}
                            type="button"
                            className={`filter-btns ${draftDateRange === key ? 'active' : ''}`}
                            onClick={() => setDraftDateRange(key)}
                        >
                            <span className="filter-btns-txt">{t(label)}</span>
                        </button>
                    ))}
                </div>
            </div>
            <button
                type="button"
                className="apply-btn"
                onClick={() => onApply(draftOrderType, draftDateRange)}
            >
                <span className="apply-btn-txt">{t(T.APPLY)}</span>
            </button>
        </div>
    );
};
